{
  "dss": {
    "button": {
      "back": "Voltar",
      "cancel": "Cancelar",
      "close": "Fechar",
      "confirmDelete": "Sim, excluir",
      "continue": "Continuar",
      "logout": "Sair",
      "passwordReset": "Redefinir senha",
      "save": "Salvar",
      "verify": "Verificar"
    },
    "error": {
      "403": "Você não tem acesso a esta página.",
      "404": "Esta página não existe.",
      "generic": "Ocorreu um erro. Tente novamente mais tarde.",
      "invalidConfirmationLink": "O link de confirmação expirou ou é inválido.",
      "throttling": "Muitas tentativas. Essa operação está bloqueada por um tempo.",
      "title": "Erro",
      "title403": "Acesso negado",
      "title404": "Não encontrado"
    },
    "footer": {
      "imprint": "Impressão",
      "legalEntity": "STIHL Ferramentas Motorizadas Ltda.",
      "privacy": "Política de privacidade",
      "terms": "Termos & Condições de Uso"
    },
    "label": {
      "CRMAccountNumber": "Código da conta CRM",
      "contact": "Contato",
      "email": "E-mail",
      "faq": "FAQ",
      "female": "Sra.",
      "firstname": "Primeiro nome",
      "help": "Ajuda",
      "language": "Idioma",
      "lastname": "Sobrenome",
      "male": "Sr.",
      "needHelp": "Preciso de ajuda?",
      "newPassword": "Nova senha",
      "newPassword2": "Confirmar nova senha",
      "oldPassword": "Senha atual",
      "organization": "Nome da Empresa",
      "password": "Senha",
      "required": "necessário",
      "salutation": "Saudação",
      "select": "Por favor seleccione"
    },
    "lang": {
      "pt": "Português",
      "pt-BR": "Brasil Português"
    },
    "link": {
      "contact": "https://support.stihl.com/pt-BR/websso-contact/",
      "faq": "https://support.stihl.com/pt-BR/externalkbsearchwebsso/"
    },
    "name": "Autoatendimento WebSSO",
    "page": {
      "confirm": {
        "title": "Confirmar Registro",
        "wait": "Aguarde para concluir a confirmação da conta."
      },
      "otp": {
        "btnResend": "Reenviar o e-mail do código de verificação",
        "msg": {
          "invalidOTP": "A senha de uso único inserida é inválida.",
          "resendFail": "Falha ao reenviar o código. Tente novamente mais tarde."
        },
        "spamDetail": "Verifique se há um e-mail do Suporte STIHL (noreply{'@'}stihl-sso.com) em sua caixa de entrada e na pasta de spam",
        "spamTitle": "Você não recebeu um e-mail?",
        "subtitle": "Para continuar, você precisa verificar seu endereço de e-mail.",
        "title": "Verifique sua conta de usuário",
        "txtVerifyMail": "Digite o novo código de verificação que enviamos para seu endereço de e-mail {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Não há nada para atualizar.",
          "updateError": "Falha ao atualizar dados pessoais.",
          "updated": "Os dados pessoais foram atualizados.",
          "userLoadErr": "Erro ao carregar dados do usuário. Por favor, tente novamente mais tarde."
        },
        "secOrganization": "Organização",
        "secPersonal": "Não altere as informações abaixo",
        "secSettings": "Opções pessoais",
        "title": "Informações pessoais"
      },
      "postPwSet": {
        "info": "Agora você pode usar sua nova senha.",
        "link_name": "Continue to Self-Service",
        "title": "Sua senha foi alterada"
      },
      "resetPW": {
        "title": "Redefinir sua senha"
      },
      "security": {
        "2fa": {
          "availableMethods": "Métodos de 2FA disponíveis:",
          "info": "A autenticação em dois fatores (2FA) é uma funcionalidade de segurança que adiciona uma camada extra de proteção à sua conta. Para acessar, é necessário usar dois métodos de autenticação, em vez de apenas nome de usuário e senha.",
          "method": {
            "email": "E-mail",
            "emailDesc": "Receba códigos únicos enviados via e-mail para concluir as solicitações de autenticação.",
            "oath": {
              "add": {
                "button": "Registrar Aplicativo de Autenticação"
              }
            }
          }
        },
        "authenticator": "Aplicativo autenticador",
        "infoFederatedAccount": "Esta conta é gerenciada pelo provedor de identidade da sua organização, portanto a senha não pode ser alterada aqui. Para alterar sua senha, faça login pela página de login da sua organização ou entre em contato com o administrador de TI.",
        "lastUse": "Último uso em {0}.",
        "msg": {
          "invalidPassword": "Senha atual inválida fornecida.",
          "passwordAlreadyUsed": "Não é possível reutilizar as últimas 5 senhas.",
          "pwUpdateError": "Ocorreu um erro ao tentar alterar a senha.",
          "pwUpdated": "A senha foi alterada."
        },
        "noDevice": "Não configurado",
        "oathAdd": {
          "appInfo": "Para facilitar o processo de login na STIHL, você pode usar aplicativos autenticadores como {0}, {1}, {2}, etc. para gerar senhas de uso único que são usadas como um segundo fator durante o processo de login.<br/>Se você perdeu ou esqueceu seu dispositivo móvel, ainda pode usar o código 2FA enviado por e-mail a qualquer momento.<br/><br/>Siga as instruções abaixo para configurar seu dispositivo de autenticação.",
          "badCode": "Código inválido, tente novamente.",
          "error": "Ocorreu um erro ao tentar registrar o dispositivo autenticador.",
          "headScan": "1. Escaneie o código QR com seu aplicativo autenticador.",
          "headVerify": "2. Verifique o código.",
          "infoKey": "chave de configuração.",
          "infoKeyTitle": "Seu segredo de dois fatores.",
          "infoScanBottom": "Não foi possível Quer escanear? Você pode usar {0} para configurar manualmente seu aplicativo autenticador.",
          "infoVerify": "Digite o código gerado pelo seu aplicativo autenticador.",
          "success": "Seu dispositivo autenticador foi registrado. Agora você pode usá-lo para fazer login.",
          "title": "Registre seu dispositivo de Autenticação de Dois Fatores"
        },
        "oathDelete": {
          "error": "Ocorreu um erro ao tentar excluir o dispositivo autenticador.",
          "success": "O dispositivo autenticador foi excluído."
        },
        "passkeys": {
          "about": {
            "info1": "As chaves de acesso são pares de chaves criptográficas (uma pública e outra privada) que são armazenadas em um autenticador controlado por você. O autenticador pode provar que o usuário está presente e autorizado a usar a chave de acesso. Os autenticadores verificam a autorização com um PIN, senha, biometria ou senha do dispositivo, dependendo das capacidades e configurações do autenticador. Os autenticadores podem assumir várias formas, como um iPhone, dispositivo Android, Windows Hello, uma chave de segurança de hardware FIDO2 ou um gerenciador de senhas.",
            "info2": "Ao fazer login no STIHL usando uma chave de acesso, o autenticador usa criptografia de chave pública para comprovar sua identidade ao STIHL sem nunca enviar a chave de acesso. As chaves de acesso estão vinculadas ao domínio de um site, como stihl-sso.com, e requerem uma conexão segura. Isso significa que o navegador rejeita qualquer tentativa de autenticação em um site semelhante de phishing. Essas propriedades tornam as chaves de acesso altamente resistentes ao phishing e muito mais difíceis de serem comprometidas em comparação a métodos como SMS ou autenticação de dois fatores TOTP.",
            "info3": "Os serviços de chaves de acesso baseados na nuvem permitem sincronizar chaves de acesso entre dispositivos (como dispositivos Apple, Android ou gerenciadores de senhas), tornando-as acessíveis de vários locais e reduzindo o risco de perda. Uma vez configurada uma chave de acesso sincronizada em um dispositivo, ela estará disponível em diversos dispositivos que utilizam o mesmo serviço. Por exemplo, se você registrar uma chave de acesso com sua conta do iCloud usando o Touch ID do seu MacBook, poderá usar essa chave em outros dispositivos vinculados ao mesmo iCloud, utilizando o reconhecimento facial, PIN ou senha do dispositivo.",
            "title": "Sobre as Chaves de Acesso"
          },
          "add": {
            "button": "Adicionar Nova Chave de Acesso",
            "error": "Erro ao tentar adicionar a nova chave de acesso.",
            "success": "Uma nova chave de acesso foi adicionada."
          },
          "delete": {
            "button": "Excluir Chave de Acesso",
            "error": "Erro ao tentar excluir esta chave de acesso.",
            "success": "A chave de acesso foi excluída."
          },
          "edit": {
            "error": "Erro ao tentar salvar o nome da chave de acesso.",
            "name": "Nome da Chave de Acesso",
            "success": "O nome da chave de acesso foi atualizado.",
            "title": "Atribua um nome à sua chave de acesso para diferenciá-la de outras"
          },
          "info": "A chave de acesso é uma alternativa simples e segura às senhas, que valida sua identidade usando o toque, reconhecimento facial, senha do dispositivo ou um PIN.",
          "none": "Nenhuma chave de acesso configurada.",
          "reallyDelete": "Tem certeza de que deseja excluir a chave de acesso?",
          "registeredPasskeys": "Chaves de acesso registradas:",
          "title": "Chaves de Acesso"
        },
        "reallyDeleteDevice": "Tem certeza de que deseja excluir o dispositivo autenticador?",
        "secMFA": "Autenticação de dois fatores",
        "secPwdChange": "Mudar senha",
        "title": "Login e segurança"
      },
      "setPW": {
        "acceptTC": "Confirme os nossos {terms} e leia a nossa {privacy}.",
        "killSSO": "Deslogue de todas as sessões com este login",
        "msg": {
          "tokenExpired": "O link ou código da senha expirou. Siga o link para redefinir sua senha: {link}."
        },
        "privacy": "Política de privacidade de dados",
        "terms": "Termos e condições",
        "title": "Digite a nova senha"
      }
    },
    "validations": {
      "hasDigit": "Deve conter dígito(s)",
      "hasLowercase": "Deve conter caracteres minúsculos",
      "hasSpecial": "Deve conter caractere(s) especial(is): {chars}",
      "hasUppercase": "Deve conter caracteres maiúsculos",
      "invalidCharacters": "Contém caracteres inválidos",
      "maxLength": "Máximo de caracteres {max} permitidos",
      "minLength": "Mínimo de {min} caracteres necessários",
      "notSameAsEmail": "Muito semelhante ao endereço de e-mail",
      "onlyValidCharactersAllowed": "Somente letras, números e espaços são permitidos.",
      "required": "Valor exigido",
      "sameAsPassword": "As senhas não correspondem",
      "tcAccepted": "Por favor, confirme nossos termos e condições.",
      "validEmail": "Endereço de e-mail inválido.",
      "validOTP": "Digite o código de verificação."
    }
  }
}
